import { render, staticRenderFns } from "./passForm.vue?vue&type=template&id=76941d80&"
import script from "./passForm.vue?vue&type=script&lang=ts&"
export * from "./passForm.vue?vue&type=script&lang=ts&"
import style0 from "./passForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports